import Vue from "vue";
import Router from "vue-router";
import store from "@/store";
import { PLATFORM_BASE_PATH } from "@/assets/js/appConfig";
import { readCookie, createCookie, eraseCookie, checkPermissionsApp } from "@/assets/js/appFunc";
import { SIDEBAR_BTNS } from "./routerPermissionsConst";
import { ROUTER_ROUTES, EXCLUDE_DIALOG_TO_PAGE, PAGE_LIST, NO_DIAGRAM_CHECK } from "./router_routes";

Vue.use(Router);

const routes = ROUTER_ROUTES;

const router = new Router({
    mode: "history",
    base: `/${PLATFORM_BASE_PATH}/`,
    routes
});

function checkForExportRoute(to) {
    const exportRouteList = [
        `/${PLATFORM_BASE_PATH}/export?fileName`,
        `/${PLATFORM_BASE_PATH}/export?type=GDM&fileName`
    ];
    const exportRoute = exportRouteList.find((condition) => to.fullPath.includes(condition));
    if (exportRoute) {
        createCookie("initialURL", encodeURIComponent(window.location.href), 1 / 24);
    }
}

function checkUnsavedModif(to, from, next) {
    let found = false;
    const list = PAGE_LIST;
    const interfaceDirty = store().getters["main/interfaceDirty"];
    const diagramState = store().getters["diagrams/getDiagramStateModifications"];
    const perspectiveDirty = store().getters["perspectiveBuilder/getPerspectiveDirty"];
    const dialogToShow = !EXCLUDE_DIALOG_TO_PAGE.find(elem => elem.from.includes(from.path) && elem.to.includes(to.path));

    const redirectToRoute = () => {
        store().commit("main/setIsOnLoadApplication", false);
        const checkCreateNewApp = () => to.name === "highlights" && !sessionStorage.getItem("isCreateApp");
        const removeElemStorage = (v) => {
            if ((v || to.name !== "highlights") && sessionStorage.getItem("isCreateApp")) {
                sessionStorage.removeItem("isCreateApp");
            }
        };
        if (!store().getters["apps/currentApp"].id && (list.includes(to.name) || checkCreateNewApp())) {
            removeElemStorage(true);
            next({
                path: "/"
            });
        } else if (found || diagramState.length || (interfaceDirty && dialogToShow)) {
            const emitObj = { diagramState, path: from.path, name: from.name, next };
            router.app.$root.$emit("showWarningDlg", emitObj);
        } else if (perspectiveDirty) {
            const emitObj = { next };
            router.app.$root.$emit("showPerspectiveWarning", emitObj);
        } else {
            removeElemStorage();
            next();
            store().commit("main/setInterfaceDirty", false);
        }
    };

    if (!NO_DIAGRAM_CHECK.includes(from.name)) {
        const initialDiagramContent = store().getters["diagrams/copyOfInitialContentDiagram"];
        const actualDiagramContent = store().getters["diagrams/diagramConfigData"];
        const formatActualDiagram = JSON.stringify(actualDiagramContent.content);
        found = initialDiagramContent.length && actualDiagramContent && initialDiagramContent !== formatActualDiagram && !to.params.isMarkedForArchiving;
    }

    if (to.params.applicationId && !store().getters["apps/currentApp"].id) {
        store().commit("main/setIsOnLoadApplication", true);
        store().dispatch("apps/getAppSettingsInfo", { id: to.params.applicationId }).then(
            (data) => {
                store().commit("main/setActivePage", to.name);
                store().commit("apps/setCurrentApp", data.data);
                store().commit("main/setCurrentApplicationId", data.data.id);
                redirectToRoute();
            }
        )
            .catch(
                () => { redirectToRoute(); }
            );
    } else {
        redirectToRoute();
    }
}
function setConditionsRouter(to, from, next) {
    const cookie = readCookie("jwt1");

    if (cookie) {
        let base64 = cookie.split(".")[1].replace(/-/g, "+").replace(/_/g, "/");
        const padding = base64.length % 4;
        if (padding) {
            base64 += "=".repeat(4 - padding);
        }
        let cookieData = atob(base64);
        cookieData = JSON.parse(cookieData);
        if (cookieData.permissions.includes("f:ext") && to.name !== "appUserTask") {
            checkForExportRoute(to);
            window.location.href = "/login";
        }
    } else {
        checkForExportRoute(to);
        window.location.href = "/";
    }

    checkUnsavedModif(to, from, next);
}

function errorPermissionsReports(to) {
    const availablePage = ["reports", "search"];
    const checkRedirect = () => ({
        reports: to.query.processDefinitionId,
        search: to.query.perspectiveId
    });
    return availablePage.includes(to.name) && to.query.filterId && checkRedirect()[to.name] ? "/accessDenied" : "";
}

function getCurrentAppPermissions(to, from, next) {
    store()
        .dispatch("apps/actGetCurrentAppUserPermissions")
        .then(
            data => {
                const permissionsData = checkPermissionsApp(data, to.meta.permissionCode);
                const checkPermissionsLength = () => {
                    let hasPermis;
                    const { length } = Object.keys(data);
                    const checkEmptyDP = () => (data.DP && !Object.keys(data.DP).length);
                    const checkReallocate = () => (checkEmptyDP() && data.RP && Object.keys(data.RP).length === 2 && data.RP.RT && data.RP.UC);
                    if (length) {
                        hasPermis = true;
                        if ((length === 1 && checkEmptyDP()) || (length === 2 && checkReallocate())) {
                            hasPermis = false;
                        }
                    }
                    return hasPermis;
                };
                if (permissionsData) {
                    to.params.permissions = permissionsData;
                    setConditionsRouter(to, from, next);
                } else if (data && checkPermissionsLength()) {
                    const availableBtns = SIDEBAR_BTNS;
                    let hasPermissions;
                    for (let i = 0; i < availableBtns.length; i++) {
                        hasPermissions = checkPermissionsApp(data, availableBtns[i].permissionCode);
                        if (hasPermissions) {
                            const permissionArray = Object.keys(hasPermissions.permissionsData);
                            if (permissionArray.length === 1 && permissionArray[0] === "WS") {
                                next("/settings/workSchedule");
                            } else {
                                let redirectPath;
                                if (["appUserTaskDataViews", "appUserTaskAnalytics"].includes(to.name)) {
                                    redirectPath = "/accessDenied";
                                } else {
                                    const getRoute = () => `/applications/${store().getters["apps/currentApp"].id}${availableBtns[i].to}`;
                                    redirectPath = errorPermissionsReports(to) || getRoute();
                                }

                                next(redirectPath);
                                break;
                            }
                        }
                    }
                } else {
                    const redirectPath = ["appUserTaskDataViews", "appUserTaskAnalytics"].includes(to.name)
                        ? "/accessDenied" : (errorPermissionsReports(to) || "/");
                    next(redirectPath);
                }
            }
        );
}

function getAppDetails(to, from, next, appId) {
    store()
        .dispatch("apps/actGetAppDetails", appId)
        .then(app => {
            store().commit("apps/setCurrentApp", app);
            store().commit("main/setCurrentApplicationId", app.id);
            getCurrentAppPermissions(to, from, next);
        });
}

function goToRoute(to, from, next) {
    store().commit("main/setIsOnLoadApplication", false);
    store()
        .dispatch("main/checkJWT")
        .then(
            res => {
                store().dispatch("tasks/getUserDetails").then(userDetails => {
                    if (userDetails && userDetails.needsTaskRedirect) {
                        store().dispatch("tasks/getSelfTaskInfo").then(rsp => {
                            const taskPath = `/tasks/${rsp.taskId || rsp.id}`;
                            if (to.fullPath !== taskPath) {
                                next(taskPath);
                            } else {
                                next();
                            }
                        });
                    } else {
                        let sessionStorageParams;
                        const { data: { userType } = {} } = res;
                        const checkSessionStorage = () => {
                            const appReports = sessionStorage.getItem("appReportsFilterData");
                            const appCaseSearch = sessionStorage.getItem("appCaseSearchFilterData");
                            const getData = (data) => ({ ...JSON.parse(data) });

                            if (appReports) {
                                const { filterId, processDefinitionId, appId } = getData(appReports);
                                sessionStorageParams = { type: "appReportsFilterData",
                                    path: `/applications/${appId}/analytics/processLiveView/${processDefinitionId}`,
                                    query: { filterId, processDefinitionId } };
                            } else if (appCaseSearch) {
                                const { filterId, perspectiveId, processDefinitionId, appId } = getData(appCaseSearch);
                                sessionStorageParams = { type: "appCaseSearchFilterData",
                                    path: `/applications/${appId}/dataViews/${perspectiveId}`,
                                    query: { filterId, processDefinitionId } };
                            }
                            return !!(appReports || appCaseSearch);
                        };

                        if (userType) {
                            sessionStorage.setItem("sessionExpired", true);
                            eraseCookie("jwt1");
                            eraseCookie("jwt2");
                            localStorage.setItem("isUserUsr", userType === "TUSR");
                            checkForExportRoute(to);
                            window.location.href = "/login";
                        } else if (checkSessionStorage()) {
                            const { type, path, query } = sessionStorageParams;
                            sessionStorage.removeItem(type);
                            next({ path, query });
                        } else if (to.meta.checkAdmin) {
                            store()
                                .dispatch("apps/actGetUserSystemPermissions")
                                .then(data => {
                                    if (data && data.hasOwnProperty("A")) {
                                        setConditionsRouter(to, from, next);
                                    } else {
                                        next("/");
                                    }
                                });
                        } else {
                            store().dispatch("apps/actGetUserSystemPermissions").then(() => {
                                if (to.meta.permissionCode) {
                                    const checkQueryParams = (firstParam, secondParam) => {
                                        const { name, query } = to;
                                        return name === firstParam && query.filterId && query[secondParam];
                                    };
                                    const checkIfSharedFilter = checkQueryParams("reports", "processDefinitionId")
                                        || checkQueryParams("search", "perspectiveId")
                                        || sessionStorage.getItem("appReportsFilterData")
                                        || sessionStorage.getItem("appCaseSearchFilterData");
                                    const currentProcessDefId = store().getters["main/getCurrentApplicationId"];
                                    const checkApplication = (payload) => {
                                        const url = to.name === "reports" ? "getApplicationByProcessId" : "getApplicationByPerspectiveId";
                                        store().dispatch(`apps/${url}`, payload).then(data => {
                                            getAppDetails(to, from, next, data.data);
                                        })
                                            .catch(() => {
                                                next("/accessDenied");
                                            });
                                    };

                                    if (currentProcessDefId) {
                                        const localProcessDef = checkIfSharedFilter
                                            ? checkIfSharedFilter.processDefinitionId || checkIfSharedFilter.perspectiveId || checkIfSharedFilter : null;
                                        if (localProcessDef && localProcessDef !== currentProcessDefId) {
                                            checkApplication(localProcessDef);
                                        } else {
                                            getCurrentAppPermissions(to, from, next);
                                        }
                                    } else if (checkIfSharedFilter) {
                                        if (!to.query.filterId) {
                                            const { filterId, processDefinitionId, perspectiveId } = checkIfSharedFilter;
                                            to.query = {
                                                filterId,
                                                ...(processDefinitionId) && { processDefinitionId },
                                                ...(perspectiveId) && { perspectiveId }
                                            };
                                        }
                                        const payload = to.name === "reports" ? to.query.processDefinitionId : to.query.perspectiveId;
                                        checkApplication(payload);
                                    } else {
                                        setConditionsRouter(to, from, next);
                                    }
                                } else {
                                    setConditionsRouter(to, from, next);
                                }
                            })
                                .catch(() => {
                                    setConditionsRouter(to, from, next);
                                });
                        }
                    }
                });
            }
        )
        .catch(() => {
            checkForExportRoute(to);
            window.location.href = "/";
        });
}

router.beforeEach((to, from, next) => {
    const jwt1 = readCookie("jwt1");
    if (jwt1) {
        if (to.params.applicationId && !store().getters["apps/currentApp"].id) {
            store().commit("main/setIsOnLoadApplication", true);
            store().commit("main/setCurrentApplicationId", to.params.applicationId);
            store().dispatch("apps/getAppSettingsInfo", { id: to.params.applicationId }).then(
                (data) => {
                    store().commit("main/setActivePage", to.name);
                    store().commit("apps/setCurrentApp", data.data);
                    let processesList;
                    store().dispatch("apps/getAppProcesses", { applicationId: to.params.applicationId, searchTerm: "" }).then(
                        (dataProcess) => {
                            if (dataProcess && dataProcess.data) {
                                processesList = dataProcess.data;
                                store().commit("apps/setProcessList", processesList);
                            }
                            const currentProcess = store().getters["apps/currentProcess"];
                            if (to.params.processId && !currentProcess.id && processesList) {
                                const process = processesList.find(item => item.id === to.params.processId);
                                if (process) {
                                    store().commit("apps/setCurrentProcess", process);
                                    store().commit("main/setCurrentProcessId", process.id);
                                } else {
                                    window.location.href = `/${PLATFORM_BASE_PATH}/applications/${to.params.applicationId}/processes`;
                                }
                            }
                            goToRoute(to, from, next);
                        }
                    );
                }
            )
                .catch(
                    () => { goToRoute(to, from, next); }
                );
        } else {
            goToRoute(to, from, next);
        }
    } else {
        const { query: { filterId, processDefinitionId } = {}, params: { applicationId, dataViewsId } } = to;
        const checkQuery = (type) => {
            const { name, value } = type === "appCaseSearchFilterData" ? { name: "perspectiveId", value: dataViewsId }
                : { name: "processDefinitionId", value: processDefinitionId };
            const queryReports = { ...JSON.parse(sessionStorage.getItem(type)) };
            return !queryReports || (queryReports.filterId !== filterId && queryReports[name] !== value);
        };
        if (to.name === "reports" && filterId && processDefinitionId && checkQuery("appReportsFilterData")) {
            sessionStorage.setItem("appReportsFilterData", JSON.stringify({ filterId, processDefinitionId, appId: applicationId }));
        } else if (to.name === "search" && filterId && dataViewsId && checkQuery("appCaseSearchFilterData")) {
            sessionStorage.setItem("appCaseSearchFilterData",
                JSON.stringify({ filterId, perspectiveId: dataViewsId, processDefinitionId, appId: applicationId }));
        }
        setConditionsRouter(to, from, next);
    }
});

export default router;
